<span class="pedido-setor-gep-badge">
    {{setorGep | pedidoSetorGep: true:dataInicioExpedicao:dataTerminoExpedicao}}

    <!-- Expedição -->
    <span *ngIf="config?.isExpedicao && (previsaoSeparacaoExpedicaoDias != null && previsaoSeparacaoExpedicaoDias !== undefined)">
        D+{{previsaoSeparacaoExpedicaoDias}}
    </span>
</span>